import React from 'react';
import PropTypes from 'prop-types';

import {greyishBlue500, greyishBlue900} from "assets/jss/main";
import { ReactComponent as EikowLogo } from "assets/img/eikow-logo.svg";
import { ReactComponent as StripeLogo } from "assets/img/stripe-logo.svg";
import { ReactComponent as WishibamLogo } from "assets/img/wishibam-logo.svg";

import {APPLICATIONS} from "utils/Applications";

ApplicationName.propTypes = {
    application: PropTypes.number.isRequired,
    selected: PropTypes.bool
};

function ApplicationName({application = 1, selected = false}) {
    function getIcon(application) {
        switch (application) {
            case 1:
            case 2:
            case 3:
                return <WishibamLogo />;
            case 4:
                return <EikowLogo />
            case 5:
                return <StripeLogo />
        }
    }

    return (
        <div style={{
            display: 'flex',
            alignItems: 'center'
        }}>
            <div style={{
                width: '18px',
                height: '18px'
            }}>
                {getIcon(application)}
            </div>

            <span style={{
                marginLeft: '8px',
                fontSize: '14px',
                fontWeight: 600,
                color: selected ? greyishBlue900 : greyishBlue500
            }}>
                {APPLICATIONS.getName(application)}
            </span>
        </div>
    );
}

export default ApplicationName;
